


























































import Vue from "vue";
import Component from "vue-class-component";
import PaginateModel from "@/model/paginate";
import {
  AwsService as awsApi,
  IROtherIrDTO,
  IrManagerService,
} from "@/common/api";
import EditOtherIR from "@/pages/ir/edit.vue";
import qNotify from "@/common/qNotify";
import QTableHeader from "@/common/qTableHeader.vue";
import QPaginate from "@/common/qPaginate.vue";

@Component({
  name: "IrIndex",
  components: {
    QTableHeader,
    QPaginate,
    EditOtherIR,
  },
})
export default class IrIndex extends Vue {
  public initSearch = {
    sort: "created_at",
    direction: "desc",
    perPage: 20,
    currentPage: 1,
  };
  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });

  public initHeaders = [
    { id: "created_at", name: "登録日", order: "desc" },
    { id: "category", name: "カテゴリ", order: "" },
    { id: "title", name: "タイトル" },
    { id: "file", name: "PDF" },
    { id: "", name: "" },
  ];

  public headers = [];

  public editIndex = null;

  public otherIRList: IROtherIrDTO[] = [];

  mounted() {
    this.headers = JSON.parse(JSON.stringify(this.initHeaders));
    this.filter();
  }

  public filter(): void {
    let query = this.$router.currentRoute.query;
    this.doSearch(query);
  }

  public doSearch(query: any = {}): void {
    query = {
      ...this.initSearch,
      ...query,
    };
    this.getList(query);
    this.$el.querySelector(".mb__responsive-table").scrollTop = 0;
  }

  public async getList(query) {
    const result = await IrManagerService.otherIr(query);
    this.pagination = new PaginateModel({
      page: result.data.paginator.currentPage,
      pageCount: result.data.paginator.lastPages,
      start: result.data.paginator.currentPage,
      end: result.data.paginator.lastPages,
      count: result.data.paginator.total,
    });
    this.otherIRList = result.data.otherIrList;
  }

  public addOtherIR() {
    (this.$refs.editOtherIR as EditOtherIR).show();
  }

  public editOtherIR(otherIR) {
    (this.$refs.editOtherIR as EditOtherIR).show(otherIR);
  }

  public clear() {
    this.headers = JSON.parse(JSON.stringify(this.initHeaders));
    this.$router.replace({ query: {} });
    this.doSearch();
  }

  async showFile(file) {
    try {
      const result = await awsApi.awsDownloadFilePresign({
        filePath: file.name,
      });

      fetch(result.data.presign.url, { method: "GET" })
        .then((response) => {
          return response.blob();
        })
        .then((blob) => {
          var url = window.URL.createObjectURL(blob);
          window.open(url);
        });
    } catch (error) {
      qNotify.error({
        text: error.message,
      });
    }
  }
}
